<template>
  <div class="top-bar">
    <div class="top-left">
      <div class="logo-text" ><span>AcuBill网络预付费系统</span></div>
      <div class="contact">
          <div>
              <span>&copy;2018北京爱博精电科技有限公司</span>
          </div>
          <div>
              <span>售后服务电话：010-56390122</span>
          </div>
      </div>
    </div>
    <div class="top-right">
      <div class="logo-image">
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TopBar'
  }
</script>

<style scoped rel="stylesheet/scss" lang="scss">
  .top-bar {
    padding-left: 8%;
    padding-right: 8%;
    height: 60px;
    /* background: -webkit-linear-gradient(#009bac, #00acbf); !* Safari 5.1 - 6.0 *!
    background: -o-linear-gradient(#009bac, #00acbf); !* Opera 11.1 - 12.0 *!
    background: -moz-linear-gradient(#009bac, #00acbf); !* Firefox 3.6 - 15 *!
    background: linear-gradient(#009bac, #00acbf); !* 标准的语法 *!*/
    background-color: #009bac;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .top-left {
      display: flex;
      align-items: flex-end;
    }
    .top-right {
      display: flex;
      align-items: center;
    }
    .logo-text {
      color: white;
      font-size: 26px
    }

    .contact {
      color: white;
      font-size: 12px;
      margin-left: 34px;
      //margin-bottom: 3px;

      span {
        padding-right: 34px;
      }
    }

    .logo-image {
      align-self: flex-end;
      div {
        width:159px;
        height: 27px;
        background-size: 159px 27px;
        background-image: url("~@/assets/images/LOGO.png");
      }
    }
  }
</style>
